import { createTextObject, createHyperlinkObject } from './textHelpers';

const BREAK_TAG_REGEX = /<br\s*\/?>/g;

export function parseInlineFormatting(text: string, fontSize: number = 7): any[] {
    const elements: any[] = [];

    const patterns = [
        { regex: /\*\*(.+?)\*\*/, type: 'bold' },
        { regex: /\*(.+?)\*/, type: 'italic' },
        { regex: /\[(.+?)\]\((.+?)\)/, type: 'link' }
    ];

    let remaining = text;
    let matchFound = true;

    while (matchFound && remaining.length > 0) {
        matchFound = false;

        for (const { regex, type } of patterns) {
            const match = regex.exec(remaining);
            if (match) {
                matchFound = true;

                if (match.index > 0) {
                    elements.push(createTextObject(remaining.slice(0, match.index), fontSize));
                }

                switch (type) {
                    case 'bold':
                        elements.push(createTextObject(match[1], fontSize, true));
                        break;
                    case 'italic':
                        elements.push(createTextObject(match[1], fontSize, false, true));
                        break;
                    case 'link':
                        elements.push(createHyperlinkObject(match[1], match[2], fontSize));
                        break;
                }

                remaining = remaining.slice(match.index + match[0].length);
                break;
            }
        }
    }

    if (remaining.trim()) {
        elements.push(createTextObject(remaining, fontSize));
    }

    return elements;
}


export function removeBreakTags(text: string): string {
    return text.replace(BREAK_TAG_REGEX, '');
}
